import React from 'react'
import {
  CFSelect,
  CFView,
  CFImage,
  DefaultScreen,
  MobileScreen,
} from 'components'
import { orderPickupButton } from 'images'
import { dispatch } from 'store'

export default () => {
  return (
    <CFSelect selector={dispatch.restaurant.getSelectedLocationId}>
      {locationId => (
        <CFView>
          <MobileScreen>
            <a
              href={` https://order.codefusion.tech/restaurants/HkSSxiXFTGzyrr2PQxY5/locations/8nQRzNgP2rovh82MXE4Q`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="260px" alt="About" />
              </CFView>
            </a>
          </MobileScreen>
          <DefaultScreen>
            <a
              href={` https://order.codefusion.tech/restaurants/HkSSxiXFTGzyrr2PQxY5/locations/8nQRzNgP2rovh82MXE4Q`}
            >
              <CFView hover>
                <CFImage src={orderPickupButton} maxWidth="230px" alt="About" />
              </CFView>
            </a>
          </DefaultScreen>
        </CFView>
      )}
    </CFSelect>
  )
}
